module.exports = __webpack_public_path__ + "img/JOC_3411.b99de53f.jpg";